(function() {
    'use strict';

    angular
        .module('irricrops')
        .factory('newTimelineFactory', newTimelineFactory);

    newTimelineFactory.$inject = ['global', 'File', 'newCacheManager', 'urls'];

    /* @ngInject */
    function newTimelineFactory(global, File, NCM, urls) {



      //Upload
    var subirCsvEt             = function (file, invalidFiles, data) {
      var p = File.upload(file, invalidFiles, 'vinedo/evapotranspiracion', 'evapotranspiracion');
      p.then(function(){
        NCM.action(
          "upload.vinedo.evapotranspiracion",
          data.vinedo_id,
          global.getChildren('vinedo',data.vinedo_id),
          0
        );
      });
      return p;
    };

    var subirCsvTemp           = function (file, invalidFiles, data) {
      var p = File.upload(file, invalidFiles, 'vinedo/temperaturas', 'archivo');
      p.then( function (resp) {
        NCM.action(
          "upload.vinedo.temperaturas",
          //$stateParams.id,
          data.vinedo_id,
          global.getChildren('vinedo',data.vinedo_id), //$stateParams.id),
          0 //borra de todas las fechas
        );
      });
      return p;
    };

    var subirCsvPrecip         = function (file, invalidFiles, data) {
      var p = File.upload(file, invalidFiles, 'vinedo/precipitaciones', 'archivo');
      p.then( function (resp) {
        NCM.action(
          "upload.vinedo.precipitaciones",
          data.vinedo_id,
          global.getChildren('vinedo',data.vinedo_id),
          0
        );
      });
      return p;
    };

    var descargarXlsClima      = function(data){
      if(data.periodo === undefined){
        data.periodo = temporadaFac.getActiva().periodo;
      }
      var p = File.download(
        urls.BASE+'/vinedo/excel-clima',
        {
          vinedo_id : data.vinedo_id, //.data.id,
          periodo   : data.periodo,
          filename  : "FormatoClima_"+data.vinedo_nombre+".xlsx",
          method    : "GET"
        });
        return p;
    };

    var subirXlsRR             = function (file, invalidFiles) {
      var p = File.upload(file, invalidFiles, 'vinedo/excel-riegos', 'archivo');
      return p;
    };

    var subirXlsMai = function (file, invalidFiles) {
      var p = File.upload(file, invalidFiles, 'mai/excel', 'archivo');
      return p;
    };

    var subirXlsRRTantehue     = function (file, invalidFiles) {
      var p = File.upload(file, invalidFiles, 'vinedo/excel-riegos-tantehue', 'archivo');
      return p;
    };

    var subirXlsScholander     = function (file, invalidFiles) {
      var p = File.upload(file, invalidFiles, 'vinedo/excel-scholander', 'archivo');
      return p;
    };

    var descargarXlsRiego      = function(data){
      if(data.periodo === undefined){
        data.periodo = temporadaFac.getActiva().periodo;
      }
      var p = File.download(
        urls.BASE+'/vinedo/excel-riego',
        {
          vinedo_id : data.vinedo_id,
          periodo   : data.periodo,
          filename  : "FormatoRiegoReal_"+data.vinedo_nombre+".xls",
          method    : "GET"
        });
      return p;
    };

    var descargarXlsScholander = function(data){
      if(data.periodo === undefined){
        data.periodo = temporadaFac.getActiva().periodo;
      }
      var p = File.download(
        urls.BASE+'/vinedo/excel-scholander',
        {
          vinedo_id : data.vinedo_id,
          periodo   : data.periodo,
          filename  : "FormatoScholander_"+data.vinedo_nombre+".xls",
          method    : "GET"
        });
        return p;
    };

    var subirXlsSR = function (file, invalidFiles, data) {
      var p = File.upload(file, invalidFiles, 'vinedo/excel-scholander-sta-rita', 'archivo', data);
      return p;
    };

    var subirXlsAtec = function (file, invalidFiles, data) {
      var p = File.upload(file, invalidFiles, 'vinedo/excel-sensores-atec', 'archivo', data);
      return p;
    };

    var subirXlsIrrimax = function (file, data) {
      var p= File.upload(file, null, 'vinedo/sensores-irrimax', 'archivo', data);
      return p;
    };

    var subirXlsProgramadorNetafim = function (file, data) {
      var p= File.upload(file, null, 'equipo/excel-programador-netafim', 'archivo', data);
      return p;
    };

    var subirXlsSensorNetafim = function (file, data) {
      var p= File.upload(file, null, 'vinedo/sensores-netafim', 'archivo', data);
      return p;
    };

    var subirXlsSensores       = function (file,invalidFiles, data) {
      var p= File.upload(file, invalidFiles, 'vinedo/sensores', 'archivo', data);
      return p;
    };

    var subirXlsClima          = function (file, invalidFiles, data) {
      var p = File.upload(file, invalidFiles, 'vinedo/excel-clima', 'archivo');
      p.then(function(){
        NCM.action(
          "upload.vinedo.all",
          data.vinedo_id,
          global.getChildren('vinedo', data.vinedo_id ),
          0
        );
      });
      return p;
    };



    var service = {
      upload:{
        et:{
          csv: subirCsvEt
        },
        temperatura:{
          csv: subirCsvTemp
        },
        precipitacion:{
          csv: subirCsvPrecip
        },
        riego:{
          xls: subirXlsRR,
          tantehueXls: subirXlsRRTantehue
        },
        scholander:{
          xls: subirXlsScholander
        },
        SR: {
          xls: subirXlsSR
        },
        atec: {
          xls: subirXlsAtec
        },
        irrimax: {
          xls: subirXlsIrrimax
        },
        clima:{
          xls: subirXlsClima
        },
        netafim:{
          programador: subirXlsProgramadorNetafim,
          sensor: subirXlsSensorNetafim
        },
        sensores:{
          xls: subirXlsSensores
        },
        mai:{
          xls: subirXlsMai
        }
      },
      download:{
        clima:{
          xls: descargarXlsClima
        },
        riego:{
          xls: descargarXlsRiego
        },
        scholander:{
          xls: descargarXlsScholander
        }
      }
    };
    return service;

    }
})();
